import type { ComponentChildren, JSX } from 'preact';

/**
 * Label, control, and messages.
 *
 * The control is nested inside the `<label>` for implicit association, but the
 * hint and error deliberately sit OUTSIDE it: text inside a label becomes part
 * of the control's accessible name, which would make the name drift every time a
 * hint or validation message appeared.
 */
export function Field(props: {
  label: string;
  error?: string | undefined;
  hint?: string | undefined;
  children: ComponentChildren;
}): JSX.Element {
  return (
    <div class="field">
      <label class="field-control">
        <span class="field-label">{props.label}</span>
        {props.children}
      </label>
      {props.hint !== undefined && props.error === undefined ? (
        <span class="field-hint">{props.hint}</span>
      ) : null}
      {props.error !== undefined ? (
        <span class="field-error" role="alert">
          {props.error}
        </span>
      ) : null}
    </div>
  );
}

export function EmptyState(props: { title: string; children?: ComponentChildren }): JSX.Element {
  return (
    <div class="empty-state">
      <p class="empty-state-title">{props.title}</p>
      {props.children}
    </div>
  );
}

export function ErrorBanner(props: { error: Error | undefined }): JSX.Element | null {
  if (props.error === undefined) {
    return null;
  }
  return (
    <p class="error-banner" role="alert">
      {props.error.message}
    </p>
  );
}
